import DT from 'duration-time-conversion';
import { parseTime } from '../../../shared/utils';

export default function formatTranscriptForCopy({ transcript, isSpeakers, isTimestamps }) {
  return transcript
    .map((item) => {
      const startTimeSeconds = DT.t2d(item.start) + DT.t2d('00:00.100');
      const speaker = isSpeakers && item.speaker ? `${item.speaker}: ` : '';
      const timestamp = isTimestamps ? `(${parseTime(startTimeSeconds)}) ` : '';
      return `${timestamp}${speaker}${item.text.replace(/\s+/g, ' ')}`;
    })
    .join('\n\n');
}
